// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1cK_o","footer":"ModalUpdate_footer__1LTMM"};